module.exports = __webpack_public_path__ + "img/Excel.3232baae.png";